import {
  GOVERNED_SOURCE_DIGESTS,
  GOVERNED_SOURCE_DIGEST_SCHEME,
} from './governed-source-digest-manifest';

export type GovernedSourceDigestId = keyof typeof GOVERNED_SOURCE_DIGESTS;

export { GOVERNED_SOURCE_DIGEST_SCHEME };

export function governedSourceDigest(id: GovernedSourceDigestId): string {
  const digest = GOVERNED_SOURCE_DIGESTS[id];
  if (!/^[a-f0-9]{64}$/.test(digest)) {
    throw new Error(`missing AST-normalized governed source digest: ${id}`);
  }
  return digest;
}
